import React, { FC } from 'react'
import { useTheme } from 'react-jss'
import { LightTheme } from '../theme'
import { IconProps } from './types'

export const CheckboxSelected: FC<IconProps> = (props) => {
  const theme: LightTheme = useTheme()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className="prefix____web-inspector-hide-shortcut__"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.733 0A4.267 4.267 0 0116 4.267v7.466A4.267 4.267 0 0111.733 16H4.267A4.267 4.267 0 010 11.733V4.267A4.267 4.267 0 014.267 0h7.466z"
        fill={props.fill || theme.colors.button}
      />
    </svg>
  )
}
